// PL
export const availabilityPrices = {
  header: {
    title: "Dostępność i ceny",
  },
  common: {
    today: "Dziś",
    cancel: "Anuluj",
    save: "Zapisz",
    saving: "Zapisywanie…",
  },
  pricelabs: {
    title: "Cenami zarządza PriceLabs",
    text: "Ceny są aktualizowane automatycznie i nie można ich edytować ręcznie.",
  },
  topbar: {
    calendar: "Kalendarz",
    bulkEdit: "Edycja masowa",
    configTitle: "Ustawienia kalendarza",
    syncSection: "Synchronizacja",
    resyncOta: "Zsynchronizuj ponownie z OTA",
    resyncOtaDesc: "Ponownie wysyła dostępność i ceny do kanału.",
  },
  empty: {
    noHotelTitle: "Brak ofert typu hotel",
    noHotelDesc:
      "Utwórz ofertę typu <strong>Hotel</strong> lub <strong>Kemping</strong>, aby zacząć zarządzać dostępnością i cenami.",
    goToListings: "Przejdź do ofert",
    noRoomsTitle: "Brak pokoi w ofercie: {name}",
    noRoomsDesc:
      "Ta oferta nie ma jeszcze zarejestrowanych pokoi. Dodaj jednostki w szczegółach oferty, aby zarządzać dostępnością i cenami.",
    configureListing: "Skonfiguruj ofertę",
  },
  summary: {
    roomState: "Status pokoi",
    roomsForSale: "Pokoje w sprzedaży",
    netBooked: "Rezerwacje netto",
  },
  state: {
    available: "Dostępny",
    closed: "Zamknięty",
    soldOut: "Wyprzedany",
    pastLabel: "N/d",
  },
  calendar: {
    // Liczba mnoga (vue-i18n v8, pipes) — choiceIndex = liczba pokoi / nocy
    roomsCount: "{count} pokój | {count} pokoje | {count} pokoi",
    minStayTooltip: "Minimalny pobyt: {count} noc | Minimalny pobyt: {count} noce | Minimalny pobyt: {count} nocy",
  },
  offBadge: "WYŁĄCZONA",
  offTooltip: "Sprzedaż wyłączona: ta cena nie jest oferowana w żadnym kanale. Pozostałe ceny pokoju nadal się sprzedają.",
  rateMenu: {
    open: "Opcje ceny",
    minStay: "Minimalny pobyt wg dat",
    priceLabsMinStay: "Tę cenę zarządza PriceLabs: to on ustala minimalny pobyt.",
    stopSelling: "Wstrzymaj sprzedaż tej ceny",
    stopping: "Wyłączanie sprzedaży…",
    resuming: "Ponowne włączanie sprzedaży…",
    resumeSelling: "Wznów sprzedaż tej ceny",
    derivedPriceHint: "Cena pochodna bierze cenę z ceny głównej",
    mainKeepsDerived: "Jej ceny pochodne nadal będą sprzedawane",
    mainNotYet: "Zamknięcie ceny głównej nie jest jeszcze dostępne",
  },
  derived: {
    badge: "P",
    tooltip: "Taryfa pochodna od: {parent}{rule}",
    rulePart: " · Reguła: {rule}",
  },
  tooltips: {
    syncEnabled:
      "Przelicza i ponownie wysyła dostępność oraz maksymalny pobyt do OTA (zapobiega overbookingowi).",
    syncDisabled: "Połącz obiekt z kanałem, aby włączyć synchronizację.",
    toggleClosedOpen: "Przełącz zamknięty/otwarty",
    managedByPricelabs: "Zarządzane przez PriceLabs",
    clickToEdit: "Zaznacz lub kliknij, aby edytować",
  },
  cellTitle: {
    pastDate: "Data z przeszłości",
    closed: "Zamknięty (kliknij, aby otworzyć)",
    detail:
      "Wolne: {free} · w sprzedaży {tope} z {total} · zarezerwowane: {booked} · kliknij, aby zmienić limit",
  },
  soldBadge: {
    confirmed: "Potwierdzone rezerwacje: {real}",
    withOverbooking: "Potwierdzone: {real} + overbooking: {over}",
  },
  bulkModal: {
    from: "Od",
    to: "Do",
    rangeHint:
      "Możesz tutaj zmienić zakres, aby go wydłużyć lub dopasować. (Widok odświeży wizualnie tylko bieżący miesiąc.)",
    room: "Pokój",
    whatToEdit: "Co edytować",
    optAvail: "Dostępność i zamknięcia",
    optRate: "Ceny i minimalny pobyt",
    status: "Status",
    open: "Otwórz",
    close: "Zamknij",
    cap: "limit",
    availHint:
      "To łączna liczba, którą oferujesz; rezerwacje są odejmowane automatycznie i sprzedawane są tylko wolne pokoje. Maks. {max} (pokoje w użyciu, bez tych w konserwacji).",
    mainRate: "Taryfa główna",
    mainRateHint:
      "Wybierz taryfę główną, którą chcesz zmienić; jej taryfy pochodne dostosują się automatycznie.",
    action: "Akcja",
    price: "Cena",
    minStay: "Minimalny pobyt",
    minStayNights: "Minimalny pobyt (noce)",
    minStayHelp: "1 = brak ograniczenia (wyczyść)",
  },
  syncConfirm: {
    title: "Synchronizacja z OTA",
    message:
      "Spowoduje to ponowne przeliczenie i wysłanie dostępności oraz maksymalnego pobytu z tego kalendarza do OTA.",
    confirm: "Tak, synchronizuj",
  },
  progress: {
    processing: "Przetwarzanie…",
    syncing: "Synchronizowanie kalendarza z OTA…",
    updatingAvail: "Aktualizowanie dostępności…",
    updatingRate: "Aktualizowanie taryfy…",
    applying: "Wprowadzanie zmian…",
    applyingBulk: "Wprowadzanie edycji masowej…",
    applyingIn: "Wprowadzanie w: {name}…",
  },
  toasts: {
    noPropertyToSync: "Nie ma obiektu do synchronizacji.",
    syncOk: "Kalendarz został przeliczony i zsynchronizowany z OTA.",
    syncErr: "Nie udało się zsynchronizować kalendarza z OTA.",
    loadErr: "Nie udało się wczytać informacji o hotelu.",
    maxAvailClosedBlocked:
      "Maksymalna dostępność: {capacity} (są pokoje zamknięte, zablokowane lub w konserwacji).",
    availUpdated: "Dostępność zaktualizowana",
    availUpdateErr: "Nie udało się zaktualizować dostępności",
    freeSuffix: " (wolne: {free})",
    rateUpdated: "Taryfa zaktualizowana",
    rateUpdateErr: "Nie udało się zaktualizować taryfy",
    maxAvailMaintenance:
      "Maksymalna dostępność: {capacity} (są pokoje w konserwacji lub wyłączone z użytku).",
    noDatesModifiedBooked: "Nie zmieniono żadnej daty: {count} z rezerwacjami.",
    appliedFreeDates:
      "Zastosowano do wolnych dat. Nie zmieniono dat z rezerwacjami: {count}.",
    changesApplied: "Zmiany zostały wprowadzone",
    savedNotSyncedYet: "Zapisane tutaj, ale jeszcze nie dotarło do kanałów sprzedaży. Ponowna próba nastąpi za kilka minut.",
    cannotEditDerivedPricelabs:
      "Nie można edytować taryfy pochodnej ani taryfy zarządzanej przez PriceLabs.",
    minStayNumberGte1: "Minimalny pobyt musi być liczbą >= 1.",
    invalidAction: "Nieprawidłowa akcja.",
    applyErr: "Nie udało się wprowadzić zmian",
    noRoomsToEdit: "Nie ma pokoi do edycji.",
    selectAtLeastOneRoom: "Wybierz co najmniej jeden pokój.",
    chooseAction: "Wybierz akcję.",
    selectDateRange: "Wybierz zakres dat.",
    enterValidPrice: "Wpisz prawidłową cenę.",
    minStayGte1: "Minimalny pobyt musi wynosić >= 1.",
    appliedWithErrors: "Zastosowano w pokojach: {ok}. Z błędem: {failed}",
    noDatesModifiedCapacity:
      "Nie zmieniono żadnej daty. Dni, w których taka liczba pokoi nie była możliwa: {count}.",
    bulkAppliedClamped:
      "Edycja masowa zastosowana w pokojach: {ok}. Daty, w których wartość dopasowano do liczby pokoi w użyciu: {clamped}.",
    bulkApplied: "Edycja masowa zastosowana w pokojach: {ok}.",
    bulkApplyErr: "Nie udało się zastosować edycji masowej.",
    applyChangesErr: "Nie udało się wprowadzić zmian.",
  },
  // Treść dekoracyjna (aria-hidden) dla stanu pustego
  ghost: {
    month: "MAJ 2026",
    day1: "Pon 1",
    day2: "Wt 2",
    day3: "Śr 3",
    day4: "Czw 4",
    day5: "Pt 5",
    day6: "Sob 6",
    day7: "Nd 7",
    day8: "Pon 8",
    day9: "Wt 9",
    day10: "Śr 10",
    day11: "Czw 11",
    day12: "Pt 12",
    unit1: "Apartament Deluxe",
    unit1Rooms: "(2 pokoje)",
    unit2: "Pokój standardowy",
    unit2Rooms: "(3 pokoje)",
    baseRate: "Taryfa bazowa",
    nonRefundable: "Bezzwrotna",
  },
};
